/**
 * @generated SignedSource<<190eb509f81f57560006c4b304c55d5b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nameUk",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "Endpoint",
    "kind": "LinkedField",
    "name": "endpointById",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      (v1/*: any*/),
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hints",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "InstantSettings",
        "kind": "LinkedField",
        "name": "instantSettings",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "endpointMaster_washPagesQuery",
    "selections": (v3/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "endpointMaster_washPagesQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "910e99be39ac3afc76b174515ea165ff",
    "id": null,
    "metadata": {},
    "name": "endpointMaster_washPagesQuery",
    "operationKind": "query",
    "text": "query endpointMaster_washPagesQuery(\n  $id: String\n) {\n  endpointById(id: $id) {\n    id\n    name\n    nameUk\n    hints\n    instantSettings {\n      name\n      nameUk\n    }\n  }\n}\n"
  }
};
})();

node.hash = "fd31d3bce84873f771b7b53c9848eed9";

module.exports = node;
